





























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Moment from "moment-timezone";
import "@/assets/css/table.css";

class PageReadListRequest {
  meterId: string;
  startTime: string;
  endTime: string;
  page: number;
  pageSize: number;
  sortBy: string;
  descending: boolean;
  filter: any;
}
@Component({
  components: {},
})
export default class HourInterRecord extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) meterId: string;
  pagerequest: PageReadListRequest = new PageReadListRequest();
  customerlist: any[] = [];

  page: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  totalPage: number = 0;
  tableData: any[] = [];
  create() { }
  created() {
    this.pagerequest.startTime = Moment().format("YYYY-MM-DD");
    //console.log(this.pagerequest)
  }
  changdate(val) {
    this.pagerequest.startTime = val;
  }
  get list() {
    return this.$store.state.hoursuserecord.list;
  }
  cancel() {
    this.$store.commit("hoursuserecord/setCurrentPage", 1);
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      this.$store.commit("hoursuserecord/setCurrentPage", 1);
    } else {
      this.getpage();
    }

  }
  data() {
    return {
      arealist: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  }
  pageChange(page: number) {
    //this.$store.commit("hoursuserecord/setCurrentPage", page);
    this.page = page;
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    //this.$store.commit("hoursuserecord/setPageSize", pagesize);
    this.pageSize = pagesize;
    this.getpage();
  }
  changeSort(key) {
    console.log(key);
    if (key.order !== "normal") {
      this.pagerequest.sortBy = key.key;
      if (key.order == "asc") {
        this.pagerequest.descending = false;
      } else {
        this.pagerequest.descending = true;
      }
    } else {
      this.pagerequest.sortBy = "gatherTime";
      this.pagerequest.descending = true;
    }
    this.getpage();
  }
  searchdata() {
    this.page = 1;
    this.pagerequest.page = 1;
    this.getpage();
  }
  async getpage() {
    this.pagerequest.pageSize = this.pageSize;
    this.pagerequest.page = this.page;
    this.$store.state.hoursuserecord.loading = true;
    await this.$store
      .dispatch({
        type: "hoursuserecord/hoursInterData",
        data: this.pagerequest,
      })
      .then((val) => {
        console.log(val);
        // this.$store.state.hoursuserecord.totalCount = val.totalCount;
        // this.$store.state.hoursuserecord.list = val.items;
        this.tableData = val.rows;
        this.totalCount = val.total;
        this.totalPage = val.totalPage;
        this.$store.state.hoursuserecord.loading = false;
      }).catch((err) => {
        this.$store.state.hoursuserecord.loading = false;
      })

  }
  // get pageSize() {
  //   return this.$store.state.hoursuserecord.pageSize;
  // }
  // get totalCount() {
  //   return this.$store.state.hoursuserecord.totalCount;
  // }
  get currentPage() {
    return this.$store.state.hoursuserecord.currentPage;
  }
  get loading() {
    return this.$store.state.hoursuserecord.loading;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("MeterNo"),
      key: "deviceNo",
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.deviceNo,
            },
          },
          params.row.deviceNo
        );
      },
    },
    {
      title: this.L("ReadTime"),
      key: "gatherTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.gatherTime == null
            ? ""
            : Moment(params.row.gatherTime).startOf('hour').utcOffset(0).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Hour"),
      key: "record_hour",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("FirstReadNum"),
      key: "lastRead",
      width: 130,
    },
    {
      title: this.L("LastReadNum"),
      key: "thisRead",
      width: 130,
    },
    {
      title: this.L("ThisUse"),
      key: "thisUse",
      width: 130,
    },
  ];
  @Watch("meterId")
  getitemId() {
    let dicc = {
      deviceId: this.meterId,
    };
    this.pagerequest.filter = dicc;
  }
}
